export const FILE_AUTO_DELETED_ERROR = 'FileAutoDeletedError';
